<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {
            label: String,
            value: [String, Number, Array],
            disabled: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            multiple:{
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                val: 0,
            }
        },
        methods: {
            ...mapActions({
                get_list: 'dictionary/rateArticle/get_list'
            }),
            change(v) {
                this.$emit('change', v);
            }
        },
        computed: {
            ...mapState('dictionary/rateArticle', {
                load: 'load',
                list: 'list',
            }),
            ...mapGetters('dictionary/rateArticle', {
                getById: 'getById',
            }),

        },
        watch: {
            value(v) {
                this.val = v;
            },
            val(v) {
                this.$emit('input', v);
            },
        },
        components: {},
        mounted() {
            this.val = this.value;
            this.get_list();

        },
        destroyed() {
        },
    }
</script>
<template>
    <div class="input-rate-article">
        <div class="el-input-group el-input--mini" :class="{'el-input-group--prepend': label}">
            <div class="el-input-group__prepend" v-if="label">
                {{label}}
            </div>
            <el-select v-model="val" :disabled="disabled" :clearable="clearable" :collapse-tags="multiple"  :multiple="multiple" @change="change" filterable>
                <el-option v-for="item in list" :value="item.value" :key="item.value" :label="item.label"></el-option>
            </el-select>
        </div>
        <div class="input__load" v-show="load">
            <i class="el-icon-loading"></i> Загрузка...
        </div>
    </div>
</template>
<style lang="scss">
    .input-rate-article {
        position: relative;
        .el-select {
            width: 100%;
        }
    }
</style>
